import { ReactNode, useState } from "react"
import { useCanvasPainter } from "../hooks/useCanvasPainter.tsx"
import { Rect } from "../Rect.tsx"
import { vec2 } from "../VectorMath.ts"
import { doubleStroke } from "./GraphicsUtilities.tsx"
import { Timeline } from "./Timeline.ts"

export function Playhead(props: {
  timeline: Timeline,
  playheadTime: number,
  setPlayheadGraphic: (graphic: HTMLElement | null) => void
}): ReactNode {
  const { timeline, playheadTime, setPlayheadGraphic } = props
  const xFraction = playheadTime / timeline.duration

  // This zero-width wrapper div lets me position the playhead graphic by its center.
  return <div style={{
    position: 'absolute',
    top: 0,
    left: `${xFraction * 100}%`,
    width: 0,
    height: '100%',

    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',

    cursor: 'col-resize',
  }}>
    <PlayheadGraphic setPlayheadGraphic={setPlayheadGraphic} />
  </div>
}

export const PlayheadGraphic = function PlayheadGraphic(props: {
  setPlayheadGraphic: (graphic: HTMLElement | null) => void
}): ReactNode {
  const { setPlayheadGraphic } = props
  const [canvas, setCanvas] = useState<HTMLCanvasElement | null>(null)

  const width = 13

  useCanvasPainter(canvas, { alpha: true }, (gc, canvas) => {
    const rectHeight = 10
    const triangleHeight = 5

    const lineWidth = 1
    const radius = 3

    const rect = new Rect(
      0, 0,
      width, rectHeight
    ).insetBy(lineWidth)

    const tip = new vec2(
      rect.bottomMiddle.x,
      rect.bottomMiddle.y + triangleHeight
    )

    gc.lineCap = 'round'
    gc.lineJoin = 'round'
    gc.miterLimit = 100

    gc.moveTo(tip.x, tip.y)
    gc.arcTo(...rect.bottomLeft.tuple, ...rect.middleLeft.tuple, radius)
    gc.arcTo(...rect.topLeft.tuple, ...rect.topMiddle.tuple, radius)
    gc.arcTo(...rect.topRight.tuple, ...rect.middleRight.tuple, radius)
    gc.arcTo(...rect.bottomRight.tuple, tip.x, tip.y, radius)
    gc.lineTo(tip.x, tip.y)
    gc.fillStyle = 'rgb(127 127 127 / 0.25)'
    gc.fill()

    gc.lineTo(tip.x, canvas.scrollHeight)

    doubleStroke(gc, lineWidth)
  }, [])

  return <canvas
    ref={ref => {
      setPlayheadGraphic(ref)
      setCanvas(ref)
    }}
    style={{
      width: `${width}px`,
      height: '100%',
      // border: '1px solid red',
    }} />
}
